import axiosPost from "../axiosPost";

export const gateUsuarioLugarHorarioCSVDo = async (
    {
        operacionCod,
        tipoDeDocumentoCod,
        usuarioNroDeDocumentoX,
        usuarioSexo,
        usuarioFechaDeNacimiento,
        usuarioApellidos,
        usuarioNombres,
        usuarioMail,
        gateLugarCod,
        gateHorarioCod,
        gateUsuarioLugarHorarioFH,
        gateUsuarioLugarHorarioStatus,
    },
    credentials
) => {
    const body = {
        service: "GateUsuarioLugarHorarioCSVDo",
        params: {
            operacionCod,
            tipoDeDocumentoCod,
            usuarioNroDeDocumentoX,
            usuarioSexo,
            usuarioFechaDeNacimiento,
            usuarioApellidos,
            usuarioNombres,
            usuarioMail,
            gateLugarCod,
            gateHorarioCod,
            gateUsuarioLugarHorarioFH,
            gateUsuarioLugarHorarioStatus,
        },
    };

    return await axiosPost(body, credentials);
};
